import {connect} from 'react-redux';
import {Component} from 'react';

import {getHeaders} from '../../../selectors';

import Table from './Table';

class TableWrapper extends Component {

    constructor(props) {
        super(props);

        this.ref = this.ref.bind(this);

        this.timer = 0;
        this.width = 0;
        this.node = null;
    }

    render() {
        return <Table {...this.props} ref={this.ref} />;
    }

    /**
     * @param {HTMLTableElement} node
     */
    ref(node) {
        this.node = node;

        if (node === null) return;

        this.handleWidthChange(false);
    }

    componentDidUpdate() {
        this.handleWidthChange(true);
    }

    handleWidthChange(compare) {
        const {onWidthChange} = this.props;
        const {clientWidth} = this.node;

        if (compare && this.width === clientWidth) return null;

        return onWidthChange(this.width = clientWidth);
    }

}

const mapStateToProps = state => {
    const headers = getHeaders(state);
    const {timezone} = state;

    return {
        headers,
        timezone,
    };
};

export default connect(mapStateToProps)(TableWrapper);
